import {
  CalendarBlank,
  ArrowsClockwise,
  PencilSimple,
  Trash,
} from '@phosphor-icons/react';
import { getCategoryIcon, getPriorityColor, formatAmount, formatDate, recurrenceLabel } from './taskHelpers';

export const ForecastSection = ({ forecastTasks, forecastByCurrency, onEdit, onDelete }) => {
  if (forecastTasks.length === 0) return null;

  return (
    <div className="surface-card overflow-hidden mt-6" data-testid="forecast-section">
      <div className="flex items-center gap-3 px-5 py-3 bg-gradient-to-r from-[#e0f2fe] to-[#f0f9ff]">
        <CalendarBlank size={16} className="text-[#0369a1]" weight="fill" />
        <span className="label-md text-xs text-[#0369a1] uppercase tracking-wider">Upcoming Forecast ({forecastTasks.length})</span>
        <div className="flex-1 h-px bg-[#bae6fd]"></div>
        <div className="flex gap-2">
          {Object.entries(forecastByCurrency).map(([cur, total]) => (
            <span key={cur} className="text-xs font-semibold text-[#0369a1] bg-white/60 px-2 py-0.5 rounded-full">
              {formatAmount(total, cur)}
            </span>
          ))}
        </div>
      </div>
      <div className="divide-y divide-[#f2f4f6]">
        {forecastTasks.map((task) => (
          <div
            key={task.task_id}
            className="grid grid-cols-1 sm:grid-cols-12 gap-4 p-5 bg-[#f8fcff] hover:bg-[#f0f9ff] transition-colors"
            data-testid={`forecast-item-${task.task_id}`}
          >
            <div className="sm:col-span-5 flex items-start gap-3">
              <div className="mt-1">{getCategoryIcon(task.category)}</div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-semibold text-[#596065]">{task.title}</p>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e0f2fe] text-[#0369a1] text-[10px] font-bold uppercase tracking-wider" data-testid={`forecast-badge-${task.task_id}`}>
                    <CalendarBlank size={10} weight="fill" />
                    Forecast
                  </span>
                </div>
                <p className="text-sm text-[#596065] truncate">{task.provider || task.description}</p>
                <span className={`inline-block mt-2 tag category-${task.category}`}>{task.category}</span>
                {task.recurrence && task.recurrence !== 'none' && (
                  <span className="inline-flex items-center gap-1 ml-2 mt-2 px-2 py-0.5 rounded-full bg-[#e0f2fe] text-[#0369a1] text-[10px] font-bold uppercase tracking-wider">
                    <ArrowsClockwise size={10} weight="bold" />
                    {recurrenceLabel(task.recurrence)}
                  </span>
                )}
              </div>
            </div>
            <div className="sm:col-span-2 flex items-center">
              <span className="text-sm font-medium text-[#0369a1]">{formatDate(task.due_date)}</span>
            </div>
            <div className="sm:col-span-2 flex items-center">
              <span className="font-bold text-[#596065]">{formatAmount(task.amount, task.currency)}</span>
            </div>
            <div className="sm:col-span-2 flex items-center">
              <div className={`w-10 h-10 rounded-xl ${getPriorityColor(task.priority)} flex items-center justify-center font-bold text-sm opacity-60`}>
                {task.priority}
              </div>
            </div>
            <div className="sm:col-span-1 flex items-center justify-end gap-1">
              <button
                onClick={() => onEdit(task)}
                className="p-2 hover:bg-[#e0f2fe] rounded-lg transition-colors"
                title="Edit"
                data-testid={`edit-forecast-${task.task_id}`}
              >
                <PencilSimple size={18} className="text-[#0369a1]" />
              </button>
              <button
                onClick={() => onDelete(task.task_id)}
                className="p-2 hover:bg-[#ff8b9a] rounded-lg transition-colors"
                title="Delete"
                data-testid={`delete-forecast-${task.task_id}`}
              >
                <Trash size={18} className="text-[#ba1a1a]" weight="duotone" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
